import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../syntax/index.js";
import { Converter, Unit } from "../../unit/index.js";
import { Dimension } from "./dimension.js";
const { map } = Parser;
/**
 * {@link https://drafts.csswg.org/css-values/#angles}
 *
 * @public
 */
export class Angle extends Dimension {
    static of(value, unit) {
        return new Angle(value, unit);
    }
    constructor(value, unit) {
        super(value, unit, "angle");
    }
    hasUnit(unit) {
        return this._unit === unit;
    }
    withUnit(unit) {
        if (this.hasUnit(unit)) {
            return this;
        }
        return new Angle(Converter.angle(this._value, this._unit, unit), unit);
    }
    scale(factor) {
        return new Angle(this._value * factor, this._unit);
    }
    equals(value) {
        return (value instanceof Angle &&
            super.equals(value) &&
            value._unit === this._unit);
    }
    hash(hash) {
        super.hash(hash);
        hash.writeString(this._unit);
    }
    toJSON() {
        return super.toJSON();
    }
    toString() {
        return `${this._value}${this._unit}`;
    }
}
/**
 * @public
 */
(function (Angle) {
    function isAngle(value) {
        return value instanceof Angle;
    }
    Angle.isAngle = isAngle;
    Angle.parse = map(Token.parseDimension((dimension) => Unit.isAngle(dimension.unit)), (dimension) => Angle.of(dimension.value, dimension.unit));
})(Angle || (Angle = {}));
//# sourceMappingURL=angle.js.map